export function formatDate(itemCreatedAt: any, option = 'full') {
    const date = new Date(itemCreatedAt);

    if (option === 'full') {
        return date.toLocaleString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' });
    }

    if (option === 'time') {
        return date.toLocaleTimeString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' });
    }

    if (option === 'date') {
        return date.toLocaleDateString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' });
    }

    return null;
}
